var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',[_c('md-card-header',[_vm._t("title")],2),_c('md-card-media',[_c('md-ripple',[_c('div',{staticClass:"image-card-state"},[_vm._t("imageState")],2)])],1),_c('md-card-actions',[_vm._t("first-button"),_vm._t("second-button"),_vm._t("third-button")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }